import script from "./PartnerProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerProjects.vue?vue&type=script&setup=true&lang=js"

import "./PartnerProjects.vue?vue&type=style&index=0&id=fb30e042&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb30e042"]])

export default __exports__